import {Component, Input, OnInit} from '@angular/core';
import {RuntimeEnvironment} from '../../../enums/runtime-environment.enum';
import {env} from '../../../../core/utils/utils';

@Component({
  selector: 'app-next-other-products',
  templateUrl: './next-other-products.component.html',
  styleUrls: []
})
export class NextOtherProductsComponent implements OnInit {

  @Input() title: string;
  @Input() theme: NextOtherProductTheme = NextOtherProductTheme.PINK;

  readonly ICONS_DIR = './assets/images/next-products';
  products: NextOtherProductConfig[];
  themeConfig: NextOtherProductThemeConfig;
  themeSuffix: string;

  private readonly THEMES_CONFIG: NextOtherProductThemeConfig[] = [
    {
      theme: NextOtherProductTheme.PINK,
      iconsSubDir: 'pink-theme',
      topBackgroundImage: './assets/images/next-products/pink-theme/top-background.png'
    },
    {
      theme: NextOtherProductTheme.WHITE,
      iconsSubDir: 'white-theme',
      topBackgroundImage: './assets/images/next-products/white-theme/top-background.png'
    }
  ];

  constructor() { }

  ngOnInit() {
    this.init();
  }

  getProductUrl(productConfig: NextOtherProductConfig): string {
    if (!!productConfig.urls && !!productConfig.urls.length) {
      const envUrlConfig = productConfig.urls.find(config => config.env === env());
      return envUrlConfig ? envUrlConfig.url : undefined;
    }
    return undefined;
  }

  private init(): void {
    this.themeSuffix = this.theme.toLowerCase();
    this.themeConfig = this.THEMES_CONFIG.find(config => config.theme === this.theme);
    const iconsDir = `${this.ICONS_DIR}/${this.themeConfig.iconsSubDir}`;
    this.products = [
      {
        key: NextOtherProductKey.MOTO,
        name: `NEXT_OTHER_PRODUCTS.PRODUCTS.${NextOtherProductKey.MOTO}.NAME`,
        icon: `${iconsDir}/moto.svg`,
        urls: [
          {
            env: RuntimeEnvironment.DEV,
            url: 'https://dev.kioskpolis.pl/ubezpieczenie-samochodu/kalkulator-oc-ac/'
          },
          {
            env: RuntimeEnvironment.TEST,
            url: 'https://test.kioskpolis.pl/ubezpieczenie-samochodu/kalkulator-oc-ac/'
          },
          {
            env: RuntimeEnvironment.PROD,
            url: 'https://kioskpolis.pl/ubezpieczenie-samochodu/kalkulator-oc-ac/'
          }
        ]
      },
      {
        key: NextOtherProductKey.CAR_ASSISTANCE,
        name: `NEXT_OTHER_PRODUCTS.PRODUCTS.${NextOtherProductKey.CAR_ASSISTANCE}.NAME`,
        icon: `${iconsDir}/car-assistance.svg`,
        newProduct: true,
        urls: [
          {
            env: RuntimeEnvironment.DEV,
            url: 'https://test.kioskpolis.pl/ubezpieczenie-assistance/'
          },
          {
            env: RuntimeEnvironment.TEST,
            url: 'https://test.kioskpolis.pl/ubezpieczenie-assistance/'
          },
          {
            env: RuntimeEnvironment.PROD,
            url: 'https://kioskpolis.pl/ubezpieczenie-assistance/'
          }
        ]
      },
      {
        key: NextOtherProductKey.TRAVEL,
        name: `NEXT_OTHER_PRODUCTS.PRODUCTS.${NextOtherProductKey.TRAVEL}.NAME`,
        icon: `${iconsDir}/travel.svg`,
        urls: [
          {
            env: RuntimeEnvironment.DEV,
            url: 'https://test.kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/'
          },
          {
            env: RuntimeEnvironment.TEST,
            url: 'https://test.kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/'
          },
          {
            env: RuntimeEnvironment.PROD,
            url: 'https://kioskpolis.pl/kalkulator/ubezpieczenie-turystyczne/web/'
          }
        ]
      },
      {
        key: NextOtherProductKey.CDW,
        name: `NEXT_OTHER_PRODUCTS.PRODUCTS.${NextOtherProductKey.CDW}.NAME`,
        icon: `${iconsDir}/cdw.svg`,
        newProduct: true,
        urls: [
          {
            env: RuntimeEnvironment.DEV,
            url: 'https://dev.kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/'
          },
          {
            env: RuntimeEnvironment.TEST,
            url: 'https://test.kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/'
          },
          {
            env: RuntimeEnvironment.PROD,
            url: 'https://kioskpolis.pl/kalkulator-udzial-wlasny-wynajem-auta/'
          }
        ]
      },
      {
        key: NextOtherProductKey.HOME,
        name: `NEXT_OTHER_PRODUCTS.PRODUCTS.${NextOtherProductKey.HOME}.NAME`,
        icon: `${iconsDir}/home.svg`,
        urls: [
          {
            env: RuntimeEnvironment.DEV,
            url: 'https://test.kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/'
          },
          {
            env: RuntimeEnvironment.TEST,
            url: 'https://test.kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/'
          },
          {
            env: RuntimeEnvironment.PROD,
            url: 'https://kioskpolis.pl/kalkulator-ubezpieczenie-nieruchomosci/'
          }
        ]
      },
      {
        key: NextOtherProductKey.LIFE,
        name: `NEXT_OTHER_PRODUCTS.PRODUCTS.${NextOtherProductKey.LIFE}.NAME`,
        icon: `${iconsDir}/life.svg`
      }
    ];
  }

}

export enum NextOtherProductTheme {
  PINK = 'PINK', // pink background and icons, white product circles
  WHITE = 'WHITE', // white background and icons, pink product circles
}

export interface NextOtherProductThemeConfig {
  theme: NextOtherProductTheme;
  iconsSubDir: string;
  topBackgroundImage?: string;
}

export interface NextOtherProductConfig {
  key: NextOtherProductKey;
  name: string;
  icon: string;
  newProduct?: boolean;
  urls?: NextOtherProductUrlConfig[];
  disabled?: boolean;
}

export interface NextOtherProductUrlConfig {
  env: RuntimeEnvironment;
  url: string;
}

export enum NextOtherProductKey {
  MOTO = 'MOTO',
  CAR_ASSISTANCE = 'CAR_ASSISTANCE',
  TRAVEL = 'TRAVEL',
  CDW = 'CDW',
  HOME = 'HOME',
  LIFE = 'LIFE',
}
